module.exports = __webpack_public_path__ + "ENG_SPT12-ToyBox_225003055-3486523af7eed0147919706dbc895431.png";